import { PARTNERS_IDS } from 'constants/partners';

import { AvitoStyles } from './AvitoStyles';

export const customPartnerThemePalette: Record<number, string> = {
  [PARTNERS_IDS.avito]: AvitoStyles,
};
